import React from 'react'
import PropTypes from 'prop-types'
import Spinner from '../common/Spinner';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const Report5nested = ({ tableData, showOPK, showOPKtoggle, refresh, dividerForNested }) => {
  const valueConvert = (val) => {
    return (Number(val).toFixed(2)).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",")
  }

  const getHeader = () => {
    return ['Numer konta zespołu 4','Nazwa konta zespołu 4', 'Wartość kosztu [zł]','Udział w koszcie całkowitym OPK']
  }

  const getMeanValue = (cost) => {
    if(dividerForNested==0) return 'X'
    else{
      return valueConvert(cost/dividerForNested)//=='0,00'?'X':valueConvert(cost/dividerForNested)
    }
  }
  
  if(tableData){
    return (
      < >
            {/* <tr className='text-center' style={{fontWeight:'bold'}}>
              {getHeader().map((title,i) => { return(
                <td key={i}  colSpan={i===1?'2':'1'} >
                 {title}
                </td>) })}
            </tr> */}
            {Object.entries(tableData).map(([opk, item], i) => {
              return (<React.Fragment key={opk} >
                  <tr className='' >
                    <td className='' onClick={()=>showOPKtoggle(opk)} style={{cursor: 'pointer'}}>
                      {showOPK[opk]?<i className="nc-icon nc-minimal-down" style={{marginRight: '5px'}}></i>:<i className="nc-icon nc-minimal-right" style={{marginRight: '5px'}}></i>}
                      {opk}
                    </td>
                    <td className=''>{item['name']}</td>
                    <td className='rightAlignCell'>{valueConvert(item['WARTOŚĆ KOSZTU [ZŁ]'])}</td>
                    <td className='rightAlignCell'>{valueConvert(item['sredniomiesiecznie'])}</td>
                    <td className='rightAlignCell'>{valueConvert(item['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]'])}%</td>
                    {dividerForNested!==null&&
                      <td className='rightAlignCell'>{getMeanValue(item['WARTOŚĆ KOSZTU [ZŁ]'])}</td>
                    }
                  </tr>
                  {item['children']!==undefined && showOPK[opk] &&  <>
                    {Object.getOwnPropertyNames(item['children']).length===0?
                      <tr><td colSpan='5'><i style={{marginLeft:'15px'}}>Brak danych do wyświetlenia</i></td></tr>:
                      Object.entries(item['children']).map(([opk2, item2], i2) => {
                        return (
                        <tr key={opk2} className=''>
                            <td className=''>
                              <span style={{marginLeft: '20px'}}>{opk2}</span>
                            </td>
                            <td className=''>{item2['name']}</td>
                            <td className='rightAlignCell'>{valueConvert(item2['WARTOŚĆ KOSZTU [ZŁ]'])}</td>
                            <td className='rightAlignCell'>{valueConvert(item2['sredniomiesiecznie'])}</td>
                            <td className='rightAlignCell'>{valueConvert(item2['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]'])}%</td>
                            {dividerForNested!==null&&
                              <td className='rightAlignCell'>{getMeanValue(item2['WARTOŚĆ KOSZTU [ZŁ]'])}</td>
                            }
                          </tr>
                        )
                      })
                    }</>
                  }
              </React.Fragment>)
            })}
        </>
    )
  }else{
    return <tr><td colSpan='5'><Spinner /></td></tr>
  }
}
Report5nested.propTypes = {
  tableData: PropTypes.object,
  showOPK: PropTypes.object,
  showOPKtoggle: PropTypes.func,
  refresh: PropTypes.bool.isRequired,
}
export default Report5nested
